import React, { useContext, useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { FiAlertCircle } from "react-icons/fi";
import Sub1Icon from "../../assets/images/Sub1.svg";
import { IoClose } from "react-icons/io5";
import { Language } from "../../App";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { FaTimes } from "react-icons/fa";
import MixpanelManager from "../../constants/MixpanelManager";
import { MixpanelEvents } from "../../constants/MixpanelEvents";

function BenefitsDropdown({ lang, isOpen }) {
  const [open, setOpen] = useState(false);
  const [benefits, setBenefits] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    setBenefits([]);
    setOpen(false);
    try {
      const splash = JSON.parse(localStorage.getItem('SplashData'));
      const keys = splash?.home?.benefit_keys;
      if (Array.isArray(keys) && keys.length > 0) {
        setBenefits(keys);
      }
    } catch { }
  }, [isOpen]);

  const formatKey = (key) => {
    const langKey = `benefit_${key}`;
    if (lang?.[langKey]) return lang[langKey];
    return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  return (
    <div className="ws-status-row" style={{ flexDirection: 'column', alignItems: 'stretch', padding: '9px 0 0' }}>
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', paddingBottom: open ? '8px' : '9px' }}
        onClick={() => {
          const newOpen = !open;
          if (newOpen) {
            MixpanelManager.track(MixpanelEvents.VIEW_BENEFITS, {
              
            });
          }
          setOpen(newOpen);
        }}
      >
        <span className="ws-status-row-label" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          {lang?.withsub_status_benefits || 'Benefits'}
          {open ? <MdKeyboardArrowUp size={18} color="black" /> : <MdKeyboardArrowDown size={18} color="black" />}
        </span>
        <span className="ws-badge-locked">{lang?.withoutsub_status_locked || 'Locked'}</span>
      </div>
      {open && (
        <div style={{ borderTop: '0.5px solid #E6E7EA', paddingTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {benefits.length === 0 ? (
            <p style={{ fontSize: '12px', color: '#848798', margin: 0, textAlign: 'center' }}>
              No benefits available
            </p>
          ) : (
            benefits.map((key, index) => (
              <div key={index} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '13px', color: '#0f1419' }}>{formatKey(key)}</span>
                <FaTimes
                  size={15}
                  style={{ backgroundColor: "#FFE2E2", borderRadius: "50px", padding: "2px", flexShrink: 0 }}
                  color="#FF2D55"
                />
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default function WithoutSub({ isOpen, onClose, featureName = "Ophthalmology Radar" }) {
  const { lang } = useContext(Language);
  return (
    <>
      <style>{`
        .ws-modal .modal-dialog { max-width: 440px; margin: auto; }
        .ws-modal .modal-content { border: none; border-radius: 10px; overflow: hidden; box-shadow: 0 20px 60px rgba(0,0,0,0.18); }
        .ws-header { background: linear-gradient(135deg, #1DC1DD 0%, #17a8c4 100%); padding: 36px 24px 28px; text-align: center; position: relative; }
        .ws-close-btn { position: absolute; top: 14px; right: 14px; width: 30px; height: 30px; border-radius: 50%; background: rgba(255,255,255,0.22); border: none; cursor: pointer; display: flex; align-items: center; justify-content: center; color: #fff; font-size: 15px; font-weight: 700; transition: background 0.15s; padding: 0; }
        .ws-close-btn:hover { background: rgba(255,255,255,0.35); }
        .ws-icon-wrap { width: 100px; height: 100px; display: flex; align-items: center; justify-content: center; margin: 0 auto 14px; }
        .ws-title { font-size: 20px; font-weight: 700; color: #fff; margin: 0 0 4px; letter-spacing: -0.01em; }
        .ws-subtitle { font-size: 13px; color: rgba(255,255,255,0.82); margin: 0; }
        .ws-body { padding: 20px 22px 24px; background: #fff; }
        .ws-alert { background: rgba(228, 120, 11, 0.1); border: 1px solid rgba(228, 120, 11, 0.2); border-radius: 12px; padding: 12px 14px; display: flex; gap: 10px; align-items: flex-start; margin-bottom: 18px; }
        .ws-alert-icon { width: 28px; height: 28px; border-radius: 50%; background: rgba(228, 120, 11, 0.2); display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 0.5px; }
        .ws-alert-title { font-size: 15px; font-weight: 600; color: #E4780B; margin: 0 0 3px; }
        .ws-alert-text { font-size: 12px; color: #848798; margin: 0; line-height: 1.5; }
        .ws-status-card { background: #F8F9FA; border: 1px solid #ECECEC; border-radius: 14px; padding: 14px 16px; margin-bottom: 18px; }
        .ws-status-label { font-size: 10px; font-weight: 600; letter-spacing: 0.08em; color: #848798; text-transform: uppercase; margin-bottom: 12px; }
        .ws-status-row { display: flex; align-items: center; justify-content: space-between; padding: 9px 0; }
        .ws-status-row + .ws-status-row { border-top: 0.5px solid #E6E7EA; }
        .ws-status-row-label { font-size: 14px; font-weight: 500; color: #0f1419; }
        .ws-badge-inactive { font-size: 12px; background: rgba(132, 135, 152, 0.2); border: 0.5px solid #cfd9de; border-radius: 20px; padding: 3px 12px; color: #848798; font-weight: 400; white-space: nowrap; }
        .ws-badge-locked { font-size: 12px; background: rgba(208, 4, 22, 0.14); border-radius: 20px; padding: 3px 12px; color: #D00416; font-weight: 600; white-space: nowrap; }
        .ws-cta-btn { width: 100%; background: #1DC1DD; color: #fff; border: none; border-radius: 12px; padding: 13px; font-size: 15px; font-weight: 700; cursor: pointer; letter-spacing: 0.01em; transition: background 0.15s, transform 0.1s; margin-bottom: 8px; display: block; }
        .ws-cta-btn:hover { background: #17a8c4; }
        .ws-cta-btn:active { transform: scale(0.98); }
        .ws-cta-note { font-size: 12px; color: #687684; text-align: center; margin: 0; line-height: 1.5; }
        @media (max-width: 768px) {
          .ws-modal .modal-dialog { padding: 0 16px; margin: 20px auto; }
          .ws-header { padding: 28px 20px 22px; }
          .ws-icon-wrap { width: 85px; height: 85px; }
          .ws-title { font-size: 18px; }
          .ws-subtitle { font-size: 12px; }
          .ws-body { padding: 16px 18px 20px; }
          .ws-alert { padding: 10px 12px; }
          .ws-alert-title { font-size: 14px; }
          .ws-status-card { padding: 12px 14px; }
          .ws-status-row-label { font-size: 13px; }
          .ws-cta-btn { font-size: 14px; padding: 12px; }
        }
        @media (max-width: 480px) {
          .ws-modal .modal-dialog { padding: 0 10px; margin: 12px auto; }
          .ws-header { padding: 22px 16px 18px; }
          .ws-close-btn { top: 10px; right: 10px; width: 26px; height: 26px; font-size: 13px; }
          .ws-icon-wrap { width: 70px; height: 70px; margin-bottom: 10px; }
          .ws-title { font-size: 16px; }
          .ws-subtitle { font-size: 11px; }
          .ws-body { padding: 14px 14px 18px; }
          .ws-alert { gap: 8px; padding: 10px 10px; margin-bottom: 14px; }
          .ws-alert-icon { width: 24px; height: 24px; }
          .ws-alert-title { font-size: 13px; }
          .ws-alert-text { font-size: 11px; }
          .ws-status-card { padding: 10px 12px; margin-bottom: 14px; border-radius: 10px; }
          .ws-status-row { padding: 7px 0; gap: 8px; }
          .ws-status-row-label { font-size: 12px; }
          .ws-badge-inactive, .ws-badge-locked { font-size: 11px; padding: 2px 9px; }
          .ws-cta-btn { font-size: 13px; padding: 11px; border-radius: 10px; }
          .ws-cta-note { font-size: 11px; }
        }
      `}</style>

      <Modal isOpen={isOpen} toggle={onClose} centered className="ws-modal" backdrop="static" backdropClassName="ws-backdrop">
        <div className="ws-header">
          <button className="ws-close-btn" onClick={onClose} aria-label="Close"><IoClose /></button>
          <div className="ws-icon-wrap">
            <img src={Sub1Icon} alt="subscription" style={{ width: "327px", height: "104px" }} />
          </div>
          <p className="ws-title">{lang?.withoutsub_title || "Subscription Required"}</p>
          <p className="ws-subtitle">{featureName}&nbsp;&nbsp;·&nbsp;&nbsp;{lang?.withoutsub_subtitle || "Premium Feature"}</p>
        </div>

        <div className="ws-body">
          <div className="ws-alert">
            <div className="ws-alert-icon">
              <FiAlertCircle size={16} color="#E4780B" style={{ marginLeft: "0.77px" }} />
            </div>
            <div>
              <p className="ws-alert-title">{lang?.withoutsub_alert_title || "No active subscription"}</p>
              <p className="ws-alert-text">
                {lang?.withoutsub_alert_text || `You don't currently have access to ${featureName}. Contact support to purchase a subscription and unlock this feature.`}
              </p>
            </div>
          </div>

          <div className="ws-status-card">
            <p className="ws-status-label">{lang?.withoutsub_status_label || "Account Status"}</p>
            <div className="ws-status-row">
              <span className="ws-status-row-label">{lang?.withoutsub_status_subscription || "Subscription"}</span>
              <span className="ws-badge-inactive">{lang?.withoutsub_status_inactive || "Non active"}</span>
            </div>
            <BenefitsDropdown lang={lang} isOpen={isOpen} />
          </div>

          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=support@ophthalmologyradar.com&su=Subscription%20Request%20%E2%80%93%20Ophthalmology%20Radar"
            target="_blank"
            rel="noopener noreferrer"
            className="ws-cta-btn"
            style={{ textDecoration: "none", textAlign: "center" }}
          >
            {lang?.withoutsub_cta_btn || "Contact Support"}
          </a>

          <p className="ws-cta-note">
            {lang?.withoutsub_cta_note || "You'll be redirected to your email to send a subscription request."}
          </p>
        </div>
      </Modal>
    </>
  );
}